<template>
  <div class="h-100">
    <div class="loader-cont" v-dxloader="isLoader"></div>
    <div class="row h-100" v-show="!isLoader">
      <div class="content-wrapper-before gradient-45deg-indigo-purple"></div>
      <div class="breadcrumbs-dark pb-0 pt-4" id="breadcrumbs-wrapper">
        <div class="container">
          <div class="row">
            <div class="col s10 m6 l6 alignLeft">
              <h5 class="card-title alignLeft white-text">Vendors</h5>
            </div>
            <div class="col s10 m6 l6 alignRight">
              <a @click="$router.push({path: '/app/add-vendor'})" class="btn add_btn">
                <span>Add Vendor</span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="col s12 p-0" style="height:calc(100% - 45px)">
        <div class="container p-0 h-100">
          <div class="section p-0 h-100">
            <div class="row m-0 h-100">
              <div class="col s12 m12 l12 p-0 h-100">
                <div id="responsive-table" class="card card card-default scrollspy p-0 h-100">
                  <div class="card-content h-100">
                    <div class="row">
                      <div class="search-input col s8 m5 l5">
                        <div class="sidebar-search animate fadeUp">
                          <div class="search-area">
                            <i class="material-icons mr-2 search-icon">search</i>
                            <i
                              class="material-icons mr-2 close-icon"
                              v-show="filters.search"
                              @click="filters.search=''"
                            >close</i>
                            <input
                              type="text"
                              v-model="filters.search"
                              placeholder="Search"
                              class="app-filter"
                              id="chat_filter"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row" style="height: calc(100% - 56px);overflow-y: auto">
                      <div class="col s12 vendors h-100">
                        <table class="responsive-table" v-if="vendorList.results.length">
                          <thead>
                            <tr>
                              <th data-field="index">Rep. ID</th>
                              <th data-field="id">Rep. Name</th>
                              <th data-field="name">Rep. Contact</th>
                              <th data-field="price">Business Name</th>
                              <th data-field="total">Business Contact</th>
                              <th data-field="status">Status</th>
                              <th data-field="status">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(item,index) in vendorList.results" :key="item.id">
                              <td>{{item.business_details ? item.business_details.rep_id : "-"}}</td>
                              <td>{{item.first_name}}</td>
                              <td>{{item.mobile_number}}</td>
                              <td>{{item.business_details ? item.business_details.business_name : "-"}}</td>
                              <td>{{item.business_details ? item.business_details.business_contact : "-"}}</td>
                              <td>
                                <div class="switch">
                                  <label>
                                    <input
                                      :id="'toggle' + index"
                                      :name="'toggle' + index"
                                      v-model="item.is_active"
                                      @change="onStatusChange($event,item)"
                                      type="checkbox"
                                    />
                                    <span class="lever"></span>
                                  </label>
                                </div>
                              </td>
                              <td>
                                <a
                                  @click="selectVendor(item)"
                                  data-target="modal-service"
                                  class="modal-trigger btn-floating mb-1 waves-effect waves-light"
                                >
                                  <i class="material-icons">edit</i>
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoader: true,
      filters: {
        search: ""
      },
      limit: 7,
      vendorList: {
        results: [],
        count: 0,
        previous: null,
        next: null
      }
    };
  },
  created() {
    this.listVendors();
    var thisObj = this;
    setTimeout(() => {
      Vue.scrollBottom("", () => {
        if (thisObj.vendorList.next) {
          thisObj.listVendors(thisObj.vendorList.next, true);
        }
      });
    }, 500);
  },
  methods: {
    listVendors(
      url = Constants.default.APIURL.Vendors + "?limit=" + this.limit,
      status = false
    ) {
      return new Promise(resolve => {
        ajax.get(
          url,
          res => {
            this.isLoader = false;
            if (status) {
              let temp = this.vendorList.results;
              this.vendorList = {
                count: res.data.count,
                previous: res.data.previous,
                next: res.data.next
              };
              this.vendorList.results = temp.concat(res.data.results);
            } else {
              this.vendorList = res.data;
            }
            if (this.vendorList.results.length == 0) {
              Vue.showNoDataBlock(".vendors");
            } else {
              Vue.hideNoDataBlock(".vendors");
            }
            resolve(true);
          },
          err => {
            this.isLoader = false;
            resolve(false);
          }
        );
      });
    },
    searchFilter(filter) {
      let url = Constants.default.APIURL.Vendors + "?limit=" + this.limit;
      url += filter.search ? "&q=" + filter.search : "";
      this.listVendors(url);
    },
    selectVendor(vendor) {
      this.$router.push({ path: "/app/update-vendor/" + vendor.id });
    },
    onStatusChange(e, vendor) {
      let toggle = vendor.is_active;
      setTimeout(() => {
        e.target.checked = !e.target.checked;
      }, 0);
      swal({
        title: "Are you sure?",
        text: `Do you want to ${!toggle ? "disable" : "enable"} this vendor`,
        icon: "warning",
        dangerMode: !toggle,
        buttons: {
          cancel: true,
          delete: `Yes, ${!toggle ? "disable" : "enable"}`
        }
      }).then(async willDelete => {
        if (willDelete) {
          let result = await this.deActivatePackage(vendor.id);
          if (result) {
            e.target.checked = !e.target.checked;
            vendor.is_active = e.target.checked;
          }
        }
      });
    },
    deActivatePackage(id) {
      return new Promise(resolve => {
        ajax.delete(
          Constants.default.APIURL.Vendors + id + "/",
          {},
          res => {
            resolve(true);
          },
          err => {
            resolve(false);
          }
        );
      });
    }
  },
  watch: {
    filters: {
      handler: function() {
        this.searchFilter(this.filters);
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
.btn-floating {
  color: #212121;
  background: white !important;
  i {
    color: #212121 !important;
  }
}
.search-input {
  .sidebar-search {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    padding: 0 0 1rem 0;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -moz-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  .search-area {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    width: -webkit-calc(100% - 0rem);
    width: -moz-calc(100% - 0rem);
    width: calc(100% - 0rem);
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  i {
    font-size: 1.45rem;
    height: 41px;
    margin-right: 0 !important;
    padding: 0.75rem 0.25rem 0.35rem 0.75rem;
    color: #9e9e9e;
    border-radius: 5px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    background-color: #eceff1;
  }
  .app-filter {
    height: 35px;
    margin-bottom: 0;
    padding: 0.2rem;
    color: #9e9e9e;
    border: none;
    border-radius: 5px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    background-color: #eceff1;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -moz-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    border-bottom: 0 !important;
    box-shadow: none !important;
  }
}
.search-area {
  i.close-icon {
    position: absolute;
    right: 10px;
    cursor: pointer;
    font-size: 18px;
    top: 22px;
    height: inherit;
    padding: 0;
    line-height: 0;
  }
}

a.add_btn {
  margin-top: 10px;
  margin-right: 10px;
  span {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>

